<template lang="pug">
  v-container(fluid)
    v-row.pa-10(align="center" justify="center")
      v-col(cols="12")
        v-card
          v-container(fluid)
            v-img(class="white--text align-end" height="200px" src="https://image.freepik.com/vector-gratis/futbol-o-futbol-europeo-vector-plantilla-cartel-deportivo-illutsration-campeonato-futbol-torneo-deporte-equipo_53562-4867.jpg")
            v-tabs(:grow="true")
              v-tab Resumen
              v-tab Partidos
              v-tab Categorías
              v-tab Puntos
              v-tab-item
                v-card-text
                v-row.pa-10(align="center" justify="center")
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Nombre:
                    i  {{contest.name}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Compiticion:
                    i  {{contest.competition}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Matchset:
                    i  {{contest.matchset}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Tipo:
                    i
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Estado:
                    i  {{contest.status}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Formato:
                    i  {{contest.format}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Entradas:
                    i(v-if="contest.cfg")  {{contest.cfg.entries}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Entradas Maximas:
                    i(v-if="contest.cfg")  {{contest.cfg.maxentries}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Entradas de Usuarios:
                    i(v-if="contest.cfg")  {{contest.cfg.entriesuser}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Presupuesto:
                    i(v-if="contest.cfg")  {{contest.cfg.budget}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Multiplicador:
                    i(v-if="contest.cfg")  {{contest.cfg.multiplier}}
                  v-col(cols="12" md="4" lg="3" sm="6" xs="12")
                    b Fecha de Comienzo:
                    i(v-if="contest.cfg")  {{contest.cfg.start}}
              v-tab-item
                v-card-text
                  v-row.pa-10(align="center" justify="center")
                    h5 Partidos
                    v-col(cols="12")

                      v-col(cols="4")
                        v-card
                          v-card-title
                            h5 21:00
                          v-row.px-5
                            v-col(cols="12")
                              v-row
                                v-col.text-left(cols="6" xs="12" sm="12" md="8")
                                  h3 PSG
                                v-col.text-right(cols="6"  xs="12" sm="12" md="4")
                                  h3 0
                            v-col(cols="12")
                              v-row
                                v-col.text-left(cols="6" xs="12" sm="12" md="8")
                                  h3 Borusia Dormunt
                                v-col.text-right(cols="6"  xs="12" sm="12" md="4")
                                  h3 0
              v-tab-item
                v-card-text
                  v-row.pa-10(align="center" justify="center")
                    h5 Categorias
                    v-col(cols="12")
                      v-row.pa-10(align="center" justify="center")
                        v-col(cols="12")
                          v-simple-table
                            template
                              thead.text-center
                                tr
                                  th
                                  th
                              tbody
                                tr(v-for="number in 15").text-center
                                  td Categoria {{number}}
                                  td >= {{number}}0 (%)
              v-tab-item
                v-row.pa-10(align="center" justify="center")
                  h5 Puntos
            v-divider
          v-card-text
            v-row.pa-10(align="center" justify="center")
              ContestRatings

            v-row.pa-10(align="center" justify="center")
              ContestScrutiny

            v-row.pa-10(align="center" justify="center")
              UserCard(v-for="(item,i) in 5" :key="i")

      router-link(to="/fantasy/contests/edit")
        v-btn(absolute dark fab top right color="orange").mt-8
          v-icon mdi-pencil
</template>

<script>

  import UserCard from "@/components/cards/UserCard";
  import ContestRatings from "@/components/tables/ContestRatings";
  import ContestScrutiny from "@/components/tables/ContestScrutiny";

  export default {
    name: 'FantasyContestsView',
    components: {
      ContestScrutiny,
      ContestRatings,
      UserCard
    },
    computed:{
      contest(){
        return this.$store.state.fantasy.contests.filter(x => x._id === this.$route.params.contestid)[0];
      },
      constestInfo(){
        return this.contest;
      },
    },
    created() {
      this.$store.dispatch('getContests');
    },
  }
</script>

<style lang="sass">
</style>